import type { FC, SVGProps } from 'react'

export const NoiseGate: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.5 15.25C4.91421 15.25 5.25 15.5858 5.25 16V18.5C5.25 18.9142 4.91421 19.25 4.5 19.25C4.08579 19.25 3.75 18.9142 3.75 18.5V16C3.75 15.5858 4.08579 15.25 4.5 15.25Z"
      fill="currentColor"
      fillOpacity="0.7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 16.25C7.91421 16.25 8.25 16.5858 8.25 17V18.5C8.25 18.9142 7.91421 19.25 7.5 19.25C7.08579 19.25 6.75 18.9142 6.75 18.5V17C6.75 16.5858 7.08579 16.25 7.5 16.25Z"
      fill="currentColor"
      fillOpacity="0.7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.25 5C11.25 4.58579 10.9142 4.25 10.5 4.25C10.0858 4.25 9.75 4.58579 9.75 5V12.75H3.5C3.08579 12.75 2.75 13.0858 2.75 13.5C2.75 13.9142 3.08579 14.25 3.5 14.25H9.75V18.5C9.75 18.9142 10.0858 19.25 10.5 19.25C10.9142 19.25 11.25 18.9142 11.25 18.5V14.25H12.75V18.5C12.75 18.9142 13.0858 19.25 13.5 19.25C13.9142 19.25 14.25 18.9142 14.25 18.5V14.25H15.75V18.5C15.75 18.9142 16.0858 19.25 16.5 19.25C16.9142 19.25 17.25 18.9142 17.25 18.5V14.25H20.5C20.9142 14.25 21.25 13.9142 21.25 13.5C21.25 13.0858 20.9142 12.75 20.5 12.75H17.25V10.5C17.25 10.0858 16.9142 9.75 16.5 9.75C16.0858 9.75 15.75 10.0858 15.75 10.5V12.75H14.25V7.5C14.25 7.08579 13.9142 6.75 13.5 6.75C13.0858 6.75 12.75 7.08579 12.75 7.5V12.75H11.25V5Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.5 15.25C19.9142 15.25 20.25 15.5858 20.25 16V18.5C20.25 18.9142 19.9142 19.25 19.5 19.25C19.0858 19.25 18.75 18.9142 18.75 18.5V16C18.75 15.5858 19.0858 15.25 19.5 15.25Z"
      fill="currentColor"
      fillOpacity="0.7"
    />
  </svg>
)
